// ============================================================================
// Error Messages for Admin Management Epic
// ============================================================================

/**
 * Error messages for Admin Management Epic
 * Contains validation errors and API error messages
 */
export const ADMIN_ERROR_MESSAGES = {
  // Validation errors
  REQUIRED: 'To pole jest wymagane',
  EMAIL_INVALID_FORMAT: 'Niepoprawny adres e-mail',
  PHONE_MIN_LENGTH: 'Numer telefonu musi zawierać co najmniej 9 cyfr',
  ZIP_INVALID_FORMAT: 'Nieprawidłowy format kodu pocztowego.',

  // API errors
  DEFAULT_ERROR: 'Wystąpił błąd podczas dodawania użytkownika',
  NETWORK_ERROR: 'Coś poszło nie tak. Spróbuj ponownie.',
  UNEXPECTED_ERROR: 'Wystąpił nieoczekiwany błąd. Spróbuj ponownie.',
  EMAIL_ALREADY_EXISTS: 'Ten adres e-mail jest już zarejestrowany',
  VIEW_USER_DEFAULT_ERROR:
    'Wystąpił błąd podczas pobierania danych użytkownika',
} as const;
